import React, { useMemo } from 'react';

import { RENDER_TYPE_LIST, RENDER_TYPE_TABLE } from '@/common/constants';
import List from '@/ebat/components/blocks/Common/Product/Product';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';

import { ProductDefaultProps, ProductPropTypes } from './Product.proptypes';
import Table from './Table/Table';

const Product = ({
  addToCartOptions,
  className,
  disabled,
  imageSize,
  isLoading,
  isRelatedProduct,
  product,
  sortables,
  source,
  tableRowSize,
  type,
}) => {
  const props = useMemo(
    () => ({
      addToCartOptions,
      brand: product.brand,
      categories: product.categories,
      className,
      companyAvailability: product.company_availability,
      configurations: product.configurations,
      configurationsSortables: sortables,
      configurator: product.configurator,
      customerPrice: product.price_and_stock?.price?.customer_price,
      disabled,
      discountPrice: product.price_and_stock?.price?.discount_price,
      favorite: product.favorite,
      flags: product.flags,
      hasPrice: product.price_and_stock?.has_price,
      hasStock: product.price_and_stock?.has_stock,
      id: product.id,
      image: product.image,
      imageSize: imageSize || PRODUCTS_TYPES_FORMATS[type.toUpperCase()],
      invoiceUnit: product.price_and_stock?.invoice_unit,
      isLoading,
      isRelatedProduct,
      mainSku: product.main_sku,
      manufacturerSku: product.manufacturer_sku,
      name: product.name,
      path: product.path,
      publicPrice: product.price_and_stock?.price?.public_price,
      price: product.price_and_stock?.price,
      saleUnit: product.price_and_stock?.price?.sale?.sale_unit,
      salesPackaging: product.price_and_stock?.sales_packaging,
      sku: product.sku,
      slug: product.slug,
      sortables: product.sortables,
      source,
      splitPackaging: product.price_and_stock?.split_packaging,
      stockStatus: product.price_and_stock?.stock_status,
      stocks: product.price_and_stock?.stocks,
      weeeAmount: product.price_and_stock?.price?.weee_amount,
    }),
    [
      addToCartOptions,
      className,
      disabled,
      imageSize,
      isLoading,
      isRelatedProduct,
      product,
      sortables,
      source,
      type,
    ],
  );

  return useMemo(() => {
    switch (type) {
      case RENDER_TYPE_LIST:
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <List {...props} tableRowSize={tableRowSize} isTableRow />;
      case RENDER_TYPE_TABLE:
        // TODO: WARNING Table has addToCart methods, so it could be used only in a case of add to cart
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <Table {...props} />;
      default:
        return null;
    }
  }, [props, tableRowSize, type]);
};

Product.defaultProps = {
  ...ProductDefaultProps,
};

Product.propTypes = {
  ...ProductPropTypes,
};

export default Product;
